import useDriverKYCUpload from "../../Sevices/Driver Api/useDriverKYCUpload";
import useVolunteerKyc from "./useVolunteerKyc";
import useVolunteers from "./useVolunteers";

export default function useVolunteersAllApi() {
  const { volunteer, loading, fetchVolunteerProfile, fetchAllVolunteers, updateVolunteerDutyTimeApi,
registerVolunteerApi, updateVolunteerDutyTypeApi,  } =
    useVolunteers();

  const {
    volunteerKyc,
     volunteerKycList,
    fetchVolunteerKycDetails,
    submitVolunteerKycStep,
    handleVolunteerKycAction,
    fetchAllVolunteerKycDetails,
    loading: kycLoading,
  } = useVolunteerKyc();

  const { uploadImageToServer } = useDriverKYCUpload();

  return {
    // Volunteer list
    volunteer,
    loading,

    // Volunteer profile
    fetchVolunteerProfile,
    fetchAllVolunteers,
    registerVolunteerApi, 
    updateVolunteerDutyTypeApi,
    updateVolunteerDutyTimeApi,
    
    // Volunteer KYC
    volunteerKyc,
     volunteerKycList,
    uploadImageToServer,
    fetchVolunteerKycDetails,
    submitVolunteerKycStep,
    handleVolunteerKycAction,
    fetchAllVolunteerKycDetails,
  };
}
